
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover, slideInfo },

  data() {
    return {
      serviceList: [
        { title: '健康保障', desc: '联合深圳【第一健康中心】，额外提供乙肝、艾滋、梅毒等健康检查项目', img: 'https://mm2015.mamalaile.com.cn/d985dd1118154480a4f57dfae4ecdda5.png' },
        { title: '财产保障', desc: '服务过程中出现因服务人员造成客户财产损失或丢失，平台先行赔付', img: 'https://mm2015.mamalaile.com.cn/d60cb8708a16480a5abe998fdd920187.png' },
        { title: '安全保障', desc: '联合国内知名保险太平洋保险，免费为月嫂提供服务保险', img: 'https://mm2015.mamalaile.com.cn/f836bd079553d98c4a0a35895458da56.png' },
        { title: '人员可靠保障', desc: '联合国内知名在线背景调查平台【知了】，深度彻查所有月嫂背景信息', img: 'https://mm2015.mamalaile.com.cn/2e62b39905d52c1b9f897575a1685640.png' },
        { title: '甩单保障', desc: '首设全国首家【月嫂诚信基金池】，做守信月嫂；遇月嫂故意甩单，平台先赔付1000元', img: 'https://mm2015.mamalaile.com.cn/bd5bc1b5cc34b7d1c528313a6dc8de0d.png' },
        { title: '档期保障', desc: '预留预产期前后5天作为月嫂档期缓冲期，给宝宝自由的选择权', img: 'https://mm2015.mamalaile.com.cn/50fa731d1f06de711c0198b795a5be42.png' },
        { title: '24小时售后保障', desc: '预产期超过缓冲期？服务不满意？售后团队24小时在线解决', img: 'https://mm2015.mamalaile.com.cn/f9dde25ee4b692e81a0979562bcd89f2.png' },
        { title: '特殊保障', desc: '如因不可抗力的原因造成宝宝产前或产后意外，平台退全额定金', img: 'https://mm2015.mamalaile.com.cn/08cc0d3fee52777e51f11afbe24ca9b7.png' },
        { title: '母乳喂养保障', desc: '力争每位妈妈都能实现母乳喂养，专家团队线上线下鼎力相助', img: 'https://mm2015.mamalaile.com.cn/a1761abaf5bbe0527c997e0500fae5ba.png' },
        { title: '团队服务保障', desc: '您请的不止一名月嫂，月子顾问、以后专家、母乳顾问，售后团队等竭诚为您服务', img: 'https://mm2015.mamalaile.com.cn/721e2b7a69562d82be6584b8bcfe7521.png' },
      ],
      decorateList: [
        { position: 'top-right', url: require('/src/assets/images/home_pic7_bg1@2x.png'), width: 34.27 },
        { position: 'bottom-left', url: require('/src/assets/images/home_pic3_bg1@2x.png'), width: 37.76 },
      ]
    };
  }
});
